import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
// import from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ViewDailyProductionReportsGroupbyfilters = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const pathname = window.location.pathname; // also contains: "/register"
  const [permission, setPermission] = useState({});
  const [sumallcaliber, setSumallcaliber] = useState(0);
  const [totalnetweightdroductiondailyReportPalletdetails, setTotalnetweightdroductiondailyReportPalletdetails] = useState(0);
     let season_id = localStorage.getItem("season_id");



  useEffect(() => {
        setPermission(FindModuleById(61)); 
console.log(permission);

    axios
      .get(`/daily-production-reports/groupbyfilters/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          // setValue(response.data.data.reports_groupby);
            const reports_groupby = response.data.data.reports_groupby;
  setValue(reports_groupby);
          var all_caliber = response.data.data.reports_groupby.all_caliber;
          console.log(all_caliber);
          const totalQuantity2 = all_caliber.reduce((sum, item) => sum + Number(item.sum_net_weight), 0);
          console.log(totalQuantity2);
          setSumallcaliber(totalQuantity2);
            let total11 =(
              calculateTotalFinishedNetWeight(reports_groupby.finished_products_net_weight) +
              calculateTotalFinishedNetWeight(reports_groupby.decay_total_list) +
              calculateTotalFinishedNetWeight(reports_groupby.NumberOfSmall_caliber_list) +
              calculateTotalFinishedNetWeight(reports_groupby.NumberOfPending_pallets_list) +
              calculateTotalFinishedNetWeight(reports_groupby.return_total_list) 
              
          );
          console.log(totalnetweightdroductiondailyReportPalletdetails);
          setTotalnetweightdroductiondailyReportPalletdetails(total11);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

  
// Function to calculate total net weight
const calculateTotalFinishedNetWeight = (data) => {
  if (!data || !Array.isArray(data)) {
    console.error("Invalid data array");
    return 0;
  }
  return data.reduce((total, item) => total + item.net_weight, 0);
};
const calculateTotalDecayNetWeight = (data) => {
  if (!data || !Array.isArray(data)) {
    console.error("Invalid data array");
    return 0;
  }
  return data.reduce((total, item) => total + item.net_weight, 0);
};

const calculateReturnNetWeight = (data) => {
  if (!data || !Array.isArray(data)) {
    console.error("Invalid data array");
    return 0;
  }
  return data.reduce((total, item) => total + item.net_weight, 0);
};



const handleDownload = async () => {
let season_id = localStorage.getItem("season_id");
window.open(`${base_url}/daily-production-reports/listing-groupby-excel-export/${id+'_'+season_id}`, '_blank');

};
 


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Daily Report Group By Date, Location, Shift</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-daily-reports">
                        Production Daily Reports
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Report Group By Date, Location, Shift
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Daily Report Group By Date, Location, Shift</h4><hr/> <br/>
                   <div style={{float:"right"}}>
                                      
                          <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Download Report <i className="fa fa-print" />  </button>
                                       </div>
                    <table className="table table-bordered">
                      <tbody>
                       <tr>
                        <th className="p-3">Date</th>
                        <td className="p-3">{(value.date !="")?value.date:""}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location_name ? value.location_name : ""}
                        </td>
                        </tr>
                        <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Consumption</th>
                        <td className="p-3">{value.total_consumption}</td>
                      </tr>
                      </tbody>
                     </table>
                     
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Daily Report Pallets Details </h4> <hr/> <br/>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                        <th className="p-3">Pallet Type</th>
                        <th className="p-3">Numbers of Pallets</th>
                        <th className="p-3">Net Weight</th>
                        <th className="p-3">%</th>
                        </tr>
                      </thead>
                      <tbody>
                       <tr>
                          <td className="p-3">Finished Pallets</td>     
                          <td className="p-3">{(value.NumberOfFinishedPallets && value.NumberOfFinishedPallets.length)?value.NumberOfFinishedPallets.length:0}</td>
                          <td className="p-3"> {calculateTotalFinishedNetWeight(value.finished_products_net_weight)}
                          </td>
                          <td className="p-3">
                          {(calculateTotalFinishedNetWeight(value.finished_products_net_weight)/totalnetweightdroductiondailyReportPalletdetails*100).toFixed(2)}%
                        </td>
                      </tr>
                      <tr>
                          <td className="p-3">Decay</td>
                          <td className="p-3">{(value.decay_total_list && value.decay_total_list.length)?value.decay_total_list.length:0}</td>
                          <td className="p-3">{calculateTotalDecayNetWeight(value.decay_total_list)}</td>
                          <td className="p-3">{(calculateTotalDecayNetWeight(value.decay_total_list)/totalnetweightdroductiondailyReportPalletdetails*100).toFixed(2)}%</td>
                        </tr>
                        <tr>
                          <td className="p-3">Small Caliber</td>
                          <td className="p-3">{(value.NumberOfSmall_caliber_list && value.NumberOfSmall_caliber_list.length)?value.NumberOfSmall_caliber_list.length:0}</td>
                          <td className="p-3">{calculateReturnNetWeight(value.NumberOfSmall_caliber_list)}</td>
                          <td className="p-3">{(calculateTotalDecayNetWeight(value.NumberOfSmall_caliber_list)/totalnetweightdroductiondailyReportPalletdetails*100).toFixed(2)}%</td>
                      </tr>
                      <tr>
                        <td className="p-3">Rest</td>
                          <td className="p-3">{(value.NumberOfPending_pallets && value.NumberOfPending_pallets.length)?value.NumberOfPending_pallets.length:0}</td>
                          <td className="p-3">{calculateReturnNetWeight(value.NumberOfPending_pallets_list)}</td>
                          <td className="p-3">{(calculateReturnNetWeight(value.NumberOfPending_pallets_list)/totalnetweightdroductiondailyReportPalletdetails*100).toFixed(2)}%</td>
                      </tr>
                      <tr>
                        <td className="p-3">Return</td>
                          <td className="p-3">{(value.return_total_list && value.return_total_list.length)?value.return_total_list.length:0}</td>
                          <td className="p-3">{calculateReturnNetWeight(value.return_total_list)}</td>
                          <td className="p-3"> {(calculateReturnNetWeight(value.return_total_list)/totalnetweightdroductiondailyReportPalletdetails*100).toFixed(2)}%</td>
                      </tr>
                      </tbody>
                     </table>
                   </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Daily Report Caliber Details</h4> <hr/> <br/>
                    <table className="table table-bordered">
                      <thead>
                      <tr>
                      <th className="p-3">S#</th>
                      <th className="p-3">Caliber</th>
                      <th className="p-3">Net Weight</th>
                      <th className="p-3">%</th>
                      </tr>
                      </thead>
                      <tbody>
                          {value.all_caliber &&
                          value.all_caliber.map((item, indx) => (
                            <tr   key={item.calibre || indx}> 
                              <td className="p-3">{++indx}</td>
                            
                              <td className="p-3">{item.calibre}</td>
                              <td className="p-3">{Number(item.sum_net_weight).toFixed(2)} </td>
                              <td className="p-3">{(item.sum_net_weight/sumallcaliber*100).toFixed(2)}%</td>
                              
                            </tr>
                          ))}
                      </tbody>
                     </table>
                   </div>
                </div>
              </div>
            </div>


            <div className="row">
            <div className="col-md-12">
              <section className="comp-section">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card bg-white">
                      <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                          <li className="nav-item">
                            <a className="nav-link active" href="#bottom-tab1" data-bs-toggle="tab">Number Of Finished Pallets </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#bottom-tab2" data-bs-toggle="tab">Number Of Decay Pallets </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#bottom-tab3" data-bs-toggle="tab">Number Of Pending  Pallets</a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#bottom-tab4" data-bs-toggle="tab">Number Of Return  Pallets</a>
                          </li>
                        </ul>
                        <div className="tab-content">
                          <div className="tab-pane show active" id="bottom-tab1">
                            <div className="row" id="listing-followup">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">
                                    <h5 className="p-3">Number Of Finished Pallets</h5><hr/>
                                      <table className="table table-stripped table-hover">
                                         <thead className="thead-light">
                                        <tr>

                                        <th className="p-3">S#</th>
                                        <th className="p-3">Barcode</th>
                                        <th className="p-3">Order </th>
                                        <th className="p-3">Caliber </th>
                                          <th className="p-3">Net Weight </th>
                                        </tr>

                                         </thead>
                                        {value.NumberOfFinishedPallets_list &&
                                          value.NumberOfFinishedPallets_list.map((item, indx) => (
                                            <tr   key={item.barcode_number || indx}> 
                                              <td className="p-3">{++indx}</td>
                                              <td className="p-3">
                                                  <a href={'/production-output-view/'+item.production_out_id} className="btn btn-success"  >
                                                        {item.barcode_number}
                                                  </a>
                                              </td>
                                              <td className="p-3">
                                                {item.order_id && item.order_id != ''  && (
                                                  <a href={'/orders-view/'+item.order_id} className="btn btn-success" >
                                                          {item.order_po_number}
                                                    </a>
                                                )}
                                                </td>
                                              <td className="p-3">{item.calibre}</td>
                                              <td className="p-3">{item.net_weight}(KG)</td>
                                              
                                            </tr>
                                          ))}
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="tab-pane" id="bottom-tab2">
                            <div className="row" id="listing-followup-groupby">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">
                                    <h5 className="p-3">Number Of Decay Pallets</h5><hr/>
                                    <table className="table table-stripped table-hover">
                                      <tr>
                                      <th className="p-3">S#</th>
                                      <th className="p-3">Barcode</th>
                                      {/* <th className="p-3">Order </th>
                                      <th className="p-3">Caliber </th> */}
                                        <th className="p-3">Net Weight </th>
                                      </tr>

                                      {value.decay_total_list &&
                                        value.decay_total_list.map((item, indx) => (
                                          <tr   key={item.barcode_number || indx}>
                                            <td className="p-3">{++indx}</td>
                                            <td className="p-3">
                                                <a href={'/production-output-view/'+item.production_out_id} className="btn btn-success"  >
                                                      {item.barcode_number}
                                                </a>
                                            </td>
                                            {/* <td className="p-3">
                                              {item.order_id && item.order_id != ''  && (
                                                <a href={'/orders-view/'+item.order_id} className="btn btn-success" >
                                                        {item.order_po_number}
                                                  </a>
                                              )}
                                              </td>
                                            <td className="p-3">{item.calibre}</td> */}
                                            <td className="p-3">{item.net_weight}(KG)</td>
                                            
                                          </tr>
                                        ))}
                                    </table>
                          
                              
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="tab-pane" id="bottom-tab3">
                            <div className="row" id="listing-followup-groupby">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">
                                    
                            
                                    <h5 className="p-3">Number Of Pending Pallets</h5><hr/>
                              <table className="table table-stripped table-hover">
                                <tr>
                                <th className="p-3">S#</th>
                                <th className="p-3">Barcode</th>
                                {/* <th className="p-3">Order </th> */}
                                <th className="p-3">Caliber </th>
                                  <th className="p-3">Net Weight </th>
                                </tr>

                                {value.NumberOfPending_pallets_list &&
                                  value.NumberOfPending_pallets_list.map((item, indx) => (
                                    <tr   key={item.barcode_number || indx}>
                                      <td className="p-3">{++indx}</td>
                                      <td className="p-3">
                                          <a href={'/production-output-view/'+item.production_out_id} className="btn btn-success"  >
                                                {item.barcode_number}
                                          </a>
                                      </td>
                                      {/* <td className="p-3">
                                        {item.order_id && item.order_id != ''  && (
                                          <a href={'/orders-view/'+item.order_id} className="btn btn-success"  >
                                                  {item.order_po_number}
                                            </a>
                                        )}
                                        </td> */}
                                      <td className="p-3">{item.calibre}</td>
                                      <td className="p-3">{item.net_weight}(KG)</td>
                                      
                                    </tr>
                                  ))}
                              </table>
                            
                            
                              

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                          <div className="tab-pane" id="bottom-tab4">
                            <div className="row" id="listing-followup-groupby">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                    <div className="table-responsive">
                                    <h5 className="p-3">Number Of Return Pallets</h5><hr/>
                                        <table className="table table-stripped table-hover">
                                          <tr>
                                          <th className="p-3">S#</th>
                                          <th className="p-3">Barcode</th>
                                          {/* <th className="p-3">Order </th>
                                          <th className="p-3">Caliber </th> */}
                                            <th className="p-3">Net Weight </th>
                                          </tr>

                                          {value.return_total_list &&
                                            value.return_total_list.map((item, indx) => (
                                              <tr   key={item.barcode_number || indx}>
                                                <td className="p-3">{++indx}</td>
                                                <td className="p-3">
                                                    <a href={'/production-output-view/'+item.production_out_id} className="btn btn-success"  >
                                                          {item.barcode_number}
                                                    </a>
                                                </td>
                                                {/* <td className="p-3">
                                                  {item.order_id && item.order_id != ''  && (
                                                    <a href={'/orders-view/'+item.order_id} className="btn btn-success"  >
                                                            {item.order_po_number}
                                                      </a>
                                                  )}
                                                  </td>
                                                <td className="p-3">{item.calibre}</td> */}
                                                <td className="p-3">{item.net_weight}(KG)</td>
                                                
                                              </tr>
                                            ))}
                                        </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

            

          </div>
        </div>
      </div>
    </>
  );
};
export default ViewDailyProductionReportsGroupbyfilters;
